/* eslint-disable */
import {
  ADDING_NEW_ADMIN,
  ADD_NEW_ADMIN_ERROR,
  NEW_ADMIN_ADDED,
  GETTING_ALL_ADMINS,
  SET_ALL_ADMINS,
  GET_ALL_ADMINS_ERROR,
  ADDING_NEW_ADMIN_JOB,
  NEW_ADMIN_JOB_ADDED,
  ADD_NEW_ADMIN_JOB_ERROR,
  EDIT_ADMIN_DATA,
  SET_ALL_DEALER,
  SET_ALL_RECYCLE_FACTORY,
  SET_ALL_DISPOSAL_CONTRACTOR,
  SET_ALL_TRANSPORT_CONTRACTOR,
  SET_ALL_REFRIGERANT,
  SET_ALL_CONTRACTOR,
  SET_ALL_CUSTOMER,
  SET_ALL_FILED_ENGINEER,
  SET_ALL_RECYCLE_ENGINEER,
  SET_ALL_DISPOSAL_ENGINEER,
  SET_USER_WISE_ID,
  SET_USER_OWNED,
  SET_USER_BORROWED,
  SET_USER_LENT,
  SET_USER_100KG,
  ADDING_NEW_CYLINDER,
  NEW_CYLINDER_ADDED,
  VERIFY_NAME_ERROR,
  SET_USER_20KG,
  SET_NEW_CYLINDER,
  GET_NEW_CYLINDER,
  SET_PIN_CODE,
  SET_VERIFY_STATUS,
  SET_ALL_ASSOCIATED_RECYCLE_FACTORY,
  SET_ALL_ASSOCIATED_DISPOSAL_CONTRACTOR,
  ALL_DATA_ROLE_WISE,
  SET_ALL_BUILDING,
  SEARCH_CYLINDER_USING_ID,
  SEARCH_GET_CYLINDER_USING_ID,
  SET_CYLINDER_INFO,
  EDIT_CYLINDER_FLAG,
  SET_100KG_CYLINDER_INFO,
  CYLINDER_REF_DATA_LIST,
  ASSOCIATE_DEALER,
  CERTIFICATE_DATA_LIST,
  CERTIFICATE_WISE_STATE_LIST,
  CERTIFICATE_KEY,
  SET_PARENT_DATA,
  SET_SELECTED_100_KG,
  SET_CHILD_ASSOCIATE_CONTRACTOR,
  SERVICE_KEY,
  SET_SERVICES,
  SET_SERVICE_STATE_LIST,
  SET_SELECTED_SERVICE,
  SET_RATE_CARD_INFO,
  MODAL_OPEN_CLASS_LIST,
  SET_SELECTED_CERTIFICATE,
  RESET_ADMIN_JOB,
  USER_KEY,
  SET_SELECTED_USER,
  SET_ADD_USER_LIST,
  SET_EDITED_CYLINDER_TYPE,
  SET_100KG_BORROWED,
  SET_100KG_LENT,
  SET_PARENT_USER,
  SET_NON_ASSOCIATE_USERS,
  API_LOADER,
  SET_DEALER_USER_LIST,
  SET_ASSOCIATE_RECYCLER_LIST,
  SET_ASSOCIATE_PROCESSOR_LIST,
  SET_ASSOCIATE_DISPOSER_LIST,
  SET_REPORT_PIN_CODE,
  SET_ASSOCIATE_TRANSPORTER_LIST,
  SET_VIEW_DETAILS_DATA,
  SET_ERROR_RESPONSE,
  SET_CYLINDER_NAME,
  SET_MODEL_PARENT_DATA,
  SET_FILL_CYLINDER_LIST,
  SEARCH_NON_ASSOCIATE_USERS,
  SET_UPLOAD_TYPE
} from "./types";
import get from "lodash/get";
import moment from "moment";

const initialCylinderObj = {
  hasMore: false,
  lastPage: 0,
  list: [],
  pageNo: 1
}

const initialState = {
  loader: false,
  bulkUploadType: '',
  errorResponse: { response: false, error: false },
  certificateKeyData: "",
  userKey: "",
  cylinderName: "",
  serviceList: {},
  serviceRateCard: {},
  serviceKeyData: { serviceId: "", userId: "" },
  selectedService: {},
  selectedCertificate: {},
  serviceStateList: "",
  cylinderRefData: {},
  addSelectedUser: {},
  modalOpenClass: false,
  addUserList: { list: [], pageNo: 0, hasMore: false, lastPage: 0 },
  parentAddUser: { parent: "", child: "" },
  nonAssociateUsers: {},
  searchNonAssociateUsers: {},
  searchedCylinder: {},
  userViewData: { users: [], entity: [] },
  newAdmin: {
    loading: false,
    isError: false,
    errMsg: "",
    data: {},
    created: false,
  },
  allCertificateData: {
    loading: false,
    isError: false,
    errMsg: "",
    data: [],
    lastPage: 1,
    isUpdate: false,
  },
  certificateWiseStateData: {
    loading: false,
    isError: false,
    errMsg: "",
    data: [],
    lastPage: 1,
    isUpdate: false,
  },
  userParent: {},
  userParentModel: {},
  allAdmins: {
    loading: false, isError: false, errMsg: "",
    data: [], lastPage: 1, isUpdate: false, hasMore: true,
  },
  newJob: {
    loading: false,
    isError: false,
    errMsg: "",
    data: {},
    created: false,
  },
  associateRecycler: {},
  associateDisposer: {},
  associateProcessor: {},
  associateTransporter: {},
  allDealers: {
    loading: false,
    isError: false,
    errMsg: "",
    data: [],
    lastPage: 1,
    isUpdate: false,
  },
  dealerUserList: {},
  allAssociateDealers: {
    loading: false,
    isError: false,
    errMsg: "",
    data: [],
    lastPage: 1,
    isUpdate: false,
  },
  allRecycleFactoryList: {
    loading: false,
    isError: false,
    errMsg: "",
    data: [],
    lastPage: 1,
    isUpdate: false,
  },
  allDisposalContractorList: {
    loading: false,
    isError: false,
    errMsg: "",
    data: [],
    lastPage: 1,
    isUpdate: false,
  },
  allBuildingList: {
    loading: false,
    isError: false,
    errMsg: "",
    data: [],
    lastPage: 1,
    isUpdate: false,
  },
  allTransportContractorList: {
    loading: false,
    isError: false,
    errMsg: "",
    data: [],
    lastPage: 1,
    isUpdate: false,
  },
  allRefrigerantList: {
    loading: false,
    isError: false,
    errMsg: "",
    data: [],
    lastPage: 1,
    isUpdate: false,
  },
  allContractorList: {
    loading: false,
    isError: false,
    errMsg: "",
    data: [],
    lastPage: 1,
    isUpdate: false,
  },
  childAssociateContractor: { child: {}, associate: {} },
  allCustomerList: {
    loading: false,
    isError: false,
    errMsg: "",
    data: [],
    lastPage: 1,
    isUpdate: false,
  },
  allFiledEngineerList: {
    loading: false,
    isError: false,
    errMsg: "",
    data: [],
    lastPage: 1,
    isUpdate: false,
  },
  allRecycleEngineerList: {
    loading: false,
    isError: false,
    errMsg: "",
    data: [],
    lastPage: 1,
    isUpdate: false,
  },

  setAllAssociatedRecycleFactory: {
    loading: false,
    isError: false,
    errMsg: "",
    data: [],
    lastPage: 1,
    isUpdate: false,
  },
  allDisposalEngineerList: {
    loading: false,
    isError: false,
    errMsg: "",
    data: [],
    lastPage: 1,
    isUpdate: false,
  },
  allAssociatedDisposalContractorList: {
    loading: false,
    isError: false,
    errMsg: "",
    data: [],
    lastPage: 1,
    isUpdate: false,
  },

  userWiseId: {},
  ownedList: {
    loading: false,
    isError: false,
    errMsg: "",
    data: [],
    lastPage: 1,
    isUpdate: false,
    currentPage: 1
  },
  borrowedList: {
    loading: false,
    isError: false,
    errMsg: "",
    data: [],
    lastPage: 1,
    isUpdate: false,
    currentPage: 1
  },

  fillBorrowedList: initialCylinderObj,
  fillGivenOutList: initialCylinderObj,
  fillEmptyList: initialCylinderObj,
  filledList: initialCylinderObj,

  borrowedList100Kg: {},
  lentList100Kg: {},
  lentList: {
    loading: false,
    isError: false,
    errMsg: "",
    data: [],
    lastPage: 1,
    isUpdate: false,
    currentPage: 1
  },
  recycle100kgCylinder: [],
  kgList: {
    loading: false,
    isError: false,
    errMsg: "",
    data: [],
    lastPage: 1,
    isUpdate: false,
    currentPage: 1
  },
  selected100KgCylinder: [],
  kg20List: {
    loading: false,
    isError: false,
    errMsg: "",
    data: [],
    lastPage: 1,
    isUpdate: false,
  },
  addCylinder: {
    loading: false,
    isError: false,
    errMsg: "",
    data: [],
    cylinderLastPage: 1,
    created: false,
  },
  validationName: {
    loading: false,
  },
  getCylinderData: {},
  editCylinderType: "",
  getPinCode: {},
  reportPinCode: {},
  setVerifyStatus: false,
  allTransportList: {
    loading: false,
    isError: false,
    errMsg: "",
    data: [],
    lastPage: 1,
    isUpdate: false,
  },
  allDataRoleWise: {},
  cylinderInfoData: {},
  editCylinderFlag: {
    status: false,
    id: null,
  },
};

export default (state = initialState, action) => {
  switch (action.type) {
    case CYLINDER_REF_DATA_LIST:
      return {
        ...state,
        cylinderRefData: action.payload,
      };
    case SET_ERROR_RESPONSE:
      return {
        ...state,
        errorResponse: { ...state.errorResponse, ...action.payload },
      };

    case API_LOADER:
      return {
        ...state,
        loader: action.payload,
      };
    case SET_UPLOAD_TYPE:
      return {
        ...state,
        bulkUploadType: action.payload,
      };

    case SEARCH_CYLINDER_USING_ID:
      let cloneOwnData = { ...state.ownedList };
      let cloneBorrowedList = { ...state.borrowedList };
      let cloneLentList = { ...state.lentList };
      let clone100KgList = { ...state.kgList };
      let clone20KgList = { ...state.kg20List };
      let cloneReceive100Kg = { ...state.borrowedList100Kg };
      let cloneGivenOut100Kg = { ...state.lentList100Kg };
      let searchedCylinder = {};
      if (action.payload.type === "OWNED") {
        cloneOwnData.data = action.payload?.res.list || [];
        cloneOwnData.lastPage = action.payload?.res.lastPage || [];
        cloneOwnData.currentPage = action.payload?.res.pageNo || 1;
        cloneOwnData.loading = false;
      }
      if (action.payload.type === "BORROWED") {
        cloneBorrowedList.data = action.payload?.res.list || [];
        cloneBorrowedList.lastPage = action.payload?.res.lastPage || [];
        cloneBorrowedList.currentPage = action.payload?.res.pageNo || 1;
        cloneBorrowedList.loading = false;
      }
      if (action.payload.type === "LENT") {
        cloneLentList.data = action.payload?.res.list || [];
        cloneLentList.lastPage = action.payload?.res.lastPage || [];
        cloneLentList.currentPage = action.payload?.res.pageNo || 1;
        cloneLentList.loading = false;
      }
      if (action.payload.type === "100Kg") {
        clone100KgList.data = action.payload?.res.list || [];
        clone100KgList.lastPage = action.payload?.res.lastPage || [];
        clone100KgList.currentPage = action.payload?.res.pageNo || 1;
        clone100KgList.loading = false;
      }
      if (action.payload.type === "20Kg") {
        clone20KgList.data = action.payload?.res.list || [];
        clone20KgList.lastPage = action.payload?.res.lastPage || [];
        clone20KgList.loading = false;
      }
      if (action.payload.type === "Receive100Kg") {
        cloneReceive100Kg.list = action.payload?.res.list || [];
        cloneReceive100Kg.lastPage = action.payload?.res.lastPage || [];
        cloneReceive100Kg.currentPage = action.payload?.res.pageNo || 1;
        cloneReceive100Kg.loading = false;
      }
      if (action.payload.type === "GivenOut100Kg") {
        cloneGivenOut100Kg.data = action.payload?.res.list || [];
        cloneGivenOut100Kg.lastPage = action.payload?.res.lastPage || [];
        cloneGivenOut100Kg.currentPage = action.payload?.res.pageNo || 1;
        cloneGivenOut100Kg.loading = false;
      }
      if (!action.payload.type) {
        searchedCylinder = action?.payload?.res;
      }
      return {
        ...state,
        borrowedList: cloneBorrowedList,
        lentList: cloneLentList,
        kgList: clone100KgList,
        kg20List: clone20KgList,
        ownedList: cloneOwnData,
        borrowedList100Kg: cloneReceive100Kg,
        lentList100Kg: cloneGivenOut100Kg,
        searchedCylinder: searchedCylinder
      };
    case SEARCH_GET_CYLINDER_USING_ID:
      return {
        ...state,
      };
    case ADDING_NEW_CYLINDER:
      return {
        ...state,
        addCylinder: { ...state.addCylinder, loading: true, created: false },
      };
    case VERIFY_NAME_ERROR:
      return {
        ...state,
        validationName: {
          ...state.validationName,
          loading: action.payload,
        },
      };
    case NEW_CYLINDER_ADDED:
      return {
        ...state,
        addCylinder: { ...state.addCylinder, loading: false, created: true },
      };
    case ADDING_NEW_ADMIN:
      return {
        ...state,
        newAdmin: { ...state.newAdmin, loading: true, created: false },
      };
    case SET_USER_WISE_ID:
      return {
        ...state,
        userWiseId: action.payload,
      };
    case SET_CYLINDER_NAME:
      return {
        ...state,
        cylinderName: action.payload,
      };
    case NEW_ADMIN_ADDED:
      return {
        ...state,
        newAdmin: { ...state.newAdmin, loading: false, created: true },
      };
    case ADD_NEW_ADMIN_ERROR:
      return {
        ...state,
        newAdmin: { ...state.newAdmin, loading: false },
      };
    case GETTING_ALL_ADMINS:
      return {
        ...state,
        allAdmins: { ...state.allAdmins, loading: true },
      };
    case SET_ALL_ADMINS:
      const allAdminList = get(action.payload, "list", []);
      const lastPage = get(action.payload, "lastPage", 1);
      const hasMore = get(action.payload, "hasMore");
      // eslint-disable-next-line no-unused-vars
      const requestedPage = get(action.payload, "requestedPage", 1);
      const tableData = allAdminList.map((admin) => ({
        ...admin,
        name: `${admin.firstName} ${admin.lastName}`,
        creationDate: moment(admin.creationDate).format("DD/MM/YYYY"),
      }));

      const allData = tableData;

      return {
        ...state,
        allAdmins: {
          ...state.allAdmins,
          loading: false,
          data: allData,
          lastPage: lastPage,
          hasMore: hasMore,
        },
      };
    //

    case GET_ALL_ADMINS_ERROR:
      return {
        ...state,
        allAdmins: { ...state.allAdmins, loading: false },
      };
    case ADDING_NEW_ADMIN_JOB:
      return {
        ...state,
        newJob: { ...state.newJob, loading: true, created: false },
      };
    case NEW_ADMIN_JOB_ADDED:
      return {
        ...state,
        newJob: { ...state.newJob, loading: false, created: true },
      };
    case ADD_NEW_ADMIN_JOB_ERROR:
      return {
        ...state,
        newJob: { ...state.newJob, loading: false },
      };
    case EDIT_ADMIN_DATA:
      return {
        ...state,
        newAdmin: {
          ...state.newAdmin,
          loading: false,
        },
        allAdmins: {
          ...state.allAdmins,
          loading: false,
          isUpdate: action.payload.isUpdate,
        },
      };

    case SET_ALL_DEALER:
      const allDealerData = get(action.payload, "list", []);
      const lastPages = get(action.payload, "lastPage", 1);

      return {
        ...state,
        allDealers: {
          ...state.allDealers,
          loading: false,
          data: allDealerData,
          lastPage: lastPages,
        },
      };

    case ASSOCIATE_DEALER:
      const allAssociateDealerData = get(action.payload, "list", []);
      const associateLastPages = get(action.payload, "lastPage", 1);
      return {
        ...state,
        allAssociateDealers: {
          ...state.allAssociateDealers,
          loading: false,
          data: allAssociateDealerData,
          lastPage: associateLastPages,
        },
      };

    case SET_ALL_BUILDING:
      const allBuildingData = get(action.payload, "list", []);
      const buildingLastPages = get(action.payload, "lastPage", 1);

      return {
        ...state,
        allBuildingList: {
          ...state.allBuildingList,
          loading: false,
          data: allBuildingData,
          lastPage: buildingLastPages,
        },
      };

    case SET_ALL_RECYCLE_FACTORY:
      const allRecycleFactoryData = get(action.payload, "list", []);
      const recycleLastPages = get(action.payload, "lastPage", 1);

      return {
        ...state,
        allRecycleFactoryList: {
          ...state.allRecycleFactoryList,
          loading: false,
          data: allRecycleFactoryData,
          lastPage: recycleLastPages,
        },
      };

    case SET_ALL_DISPOSAL_CONTRACTOR:
      const allDisposalContractorData = get(action.payload, "list", []);
      const disposalLastPages = get(action.payload, "lastPage", 1);

      return {
        ...state,
        allDisposalContractorList: {
          ...state.allDisposalContractorList,
          loading: false,
          data: allDisposalContractorData,
          lastPage: disposalLastPages,
        },
      };

    case SET_ALL_TRANSPORT_CONTRACTOR:
      const allTransportContractorData = get(action.payload, "list", []);
      const transportLastPages = get(action.payload, "lastPage", 1);

      return {
        ...state,
        allTransportContractorList: {
          ...state.allTransportContractorList,
          loading: false,
          data: allTransportContractorData,
          lastPage: transportLastPages,
        },
      };

    case SET_ALL_REFRIGERANT:
      const allRefrigerantData = get(action.payload, "list", []);
      const refrigerantLastPages = get(action.payload, "lastPage", 1);

      return {
        ...state,
        allRefrigerantList: {
          ...state.allRefrigerantList,
          loading: false,
          data: allRefrigerantData,
          lastPage: refrigerantLastPages,
        },
      };

    case SET_ALL_CONTRACTOR:
      const allContractorData = get(action.payload, "list", []);
      const contractorLastPages = get(action.payload, "lastPage", 1);

      return {
        ...state,
        allContractorList: {
          ...state.allContractorList,
          loading: false,
          data: allContractorData,
          lastPage: contractorLastPages,
        },
      };
    case SET_ALL_CUSTOMER:
      const allCustomerData = get(action.payload, "list", []);
      const customerLastPages = get(action.payload, "lastPage", 1);

      return {
        ...state,
        allCustomerList: {
          ...state.allCustomerList,
          loading: false,
          data: allCustomerData,
          lastPage: customerLastPages,
        },
      };
    case SET_ALL_FILED_ENGINEER:
      const allFiledEngineerData = get(action.payload, "list", []);
      const allFiledEngineerLastPages = get(action.payload, "lastPage", 1);

      return {
        ...state,
        allFiledEngineerList: {
          ...state.allFiledEngineerList,
          loading: false,
          data: allFiledEngineerData,
          lastPage: allFiledEngineerLastPages,
        },
      };

    case SET_ALL_ASSOCIATED_RECYCLE_FACTORY:
      const allAssociatedRecycleFactory = get(action.payload, "list", []);

      const allAssociatedRecycleFactoryLastPages = get(
        action.payload,
        "lastPage",
        1
      );

      return {
        ...state,
        setAllAssociatedRecycleFactory: {
          ...state.setAllAssociatedRecycleFactory,
          loading: false,
          data: allAssociatedRecycleFactory,
          lastPage: allAssociatedRecycleFactoryLastPages,
        },
      };

    case SET_ALL_ASSOCIATED_DISPOSAL_CONTRACTOR:
      // -----------------
      const allAssociatedDisposalContractor = get(action.payload, "list", []);
      const allAssociatedDisposalContractorLastPages = get(
        action.payload,
        "lastPage",
        1
      );

      return {
        ...state,
        allAssociatedDisposalContractorList: {
          ...state.allAssociatedDisposalContractorList,
          loading: false,
          data: allAssociatedDisposalContractor,
          lastPage: allAssociatedDisposalContractorLastPages,
        },
      };

    case SET_ALL_RECYCLE_ENGINEER:
      const allRecycleEngineerData = get(action.payload, "list", []);
      const allRecycleEngineerLastPages = get(action.payload, "lastPage", 1);

      return {
        ...state,
        allRecycleEngineerList: {
          ...state.allRecycleEngineerList,
          loading: false,
          data: allRecycleEngineerData,
          lastPage: allRecycleEngineerLastPages,
        },
      };
    case SET_ALL_DISPOSAL_ENGINEER:
      const allDisposalEngineerData = get(action.payload, "list", []);
      const allDisposalEngineerLastPages = get(action.payload, "lastPage", 1);

      return {
        ...state,
        allDisposalEngineerList: {
          ...state.allDisposalEngineerList,
          loading: false,
          data: allDisposalEngineerData,
          lastPage: allDisposalEngineerLastPages,
        },
      };

    case SET_USER_OWNED:
      const allUserOwnedList = get(action.payload, "list", []);
      const allUserOwnedLastPages = get(action.payload, "lastPage", 1);
      const allUserOwnedCurrentPages = get(action.payload, "pageNo", 1);

      return {
        ...state,
        ownedList: {
          ...state.ownedList,
          loading: false,
          data: allUserOwnedList,
          lastPage: allUserOwnedLastPages,
          currentPage: allUserOwnedCurrentPages,
        },
      };

    case SET_USER_BORROWED:
      const allUserBorrowedList = get(action.payload, "list", []);
      const allUserBorrowedLastPages = get(action.payload, "lastPage", 1);
      const allUserBorrowedCurrentPages = get(action.payload, "pageNo", 1);

      return {
        ...state,
        borrowedList: {
          ...state.borrowedList,
          loading: false,
          data: allUserBorrowedList,
          lastPage: allUserBorrowedLastPages,
          currentPage: allUserBorrowedCurrentPages,
        },
      };

    case SET_100KG_BORROWED:
      return {
        ...state,
        borrowedList100Kg: action?.payload,
      };
    case SET_100KG_LENT:
      return {
        ...state,
        lentList100Kg: action?.payload,
      };

    case SET_USER_LENT:
      const allUserLentList = get(action.payload, "list", []);
      const allUserLentLastPages = get(action.payload, "lastPage", 1);
      const allUserLentCurrentPages = get(action.payload, "pageNo", 1);

      return {
        ...state,
        lentList: {
          ...state.lentList,
          loading: false,
          data: allUserLentList,
          lastPage: allUserLentLastPages,
          currentPage: allUserLentCurrentPages,
        },
      };

    case SET_USER_100KG:
      const allUser100kgList = get(action.payload, "list", []);
      const allUser100kgLastPages = get(action.payload, "lastPage", 1);
      const allUser100kgCurrentPages = get(action.payload, "pageNo", 1);

      return {
        ...state,
        kgList: {
          ...state.kgList,
          loading: false,
          data: allUser100kgList,
          lastPage: allUser100kgLastPages,
          currentPage: allUser100kgCurrentPages,
        },
      };
    case SET_USER_20KG:
      const allUser20kgList = get(action.payload, "list", []);
      const allUser20kgLastPages = get(action.payload, "lastPage", 1);

      return {
        ...state,
        kg20List: {
          ...state.kg20List,
          loading: false,
          data: allUser20kgList,
          lastPage: allUser20kgLastPages,
        },
      };

    case SET_NEW_CYLINDER:
      const allCylinderList = get(action.payload);

      return {
        ...state,
        addCylinder: {
          ...state.addCylinder,
          loading: false,
          data: allCylinderList,
          hasMore: hasMore,
        },
      };
    case CERTIFICATE_DATA_LIST:
      const allCertificateList = get(action.payload, "list", []);
      const allCertificatePages = get(action.payload, "lastPage", 1);

      return {
        ...state,
        allCertificateData: {
          ...state.allCertificateData,
          loading: false,
          data: allCertificateList,
          lastPage: allCertificatePages,
        },
      };
    case CERTIFICATE_WISE_STATE_LIST:
      const allCertificateWiseStateList = get(action.payload, "list", []);
      const allCertificateStatePages = get(action.payload, "lastPage", 1);

      return {
        ...state,
        certificateWiseStateData: {
          ...state.certificateWiseStateData,
          loading: false,
          data: allCertificateWiseStateList,
          lastPage: allCertificateStatePages,
        },
      };

    case SET_PIN_CODE:
      const allPinCode = action.payload;

      return {
        ...state,
        getPinCode: allPinCode,
      };

    case SET_REPORT_PIN_CODE:
      return {
        ...state,
        reportPinCode: action.payload,
      };

    case SET_VERIFY_STATUS:
      return {
        ...state,
        setVerifyStatus: action.payload,
      };

    case GET_NEW_CYLINDER:
      return {
        ...state,
        getCylinderData: action.payload,
      };
    case ALL_DATA_ROLE_WISE:
      return {
        ...state,
        allDataRoleWise: action.payload,
      };
    case SET_CYLINDER_INFO:
      return {
        ...state,
        cylinderInfoData: action.payload,
      };

    case EDIT_CYLINDER_FLAG:
      return {
        ...state,
        editCylinderFlag: action.payload,
      };

    case SET_100KG_CYLINDER_INFO:
      return {
        ...state,
        recycle100kgCylinder: action.payload,
      };

    case CERTIFICATE_KEY:
      return {
        ...state,
        certificateKeyData: action.payload,
      };

    case SERVICE_KEY:
      return {
        ...state,
        serviceKeyData: action.payload,
      };

    case SET_PARENT_DATA:
      return {
        ...state,
        userParent: action.payload,
      };

    case SET_MODEL_PARENT_DATA:
      return {
        ...state,
        userParentModel: action.payload,
      };

    case SET_SELECTED_100_KG:
      return {
        ...state,
        selected100KgCylinder: action.payload,
      };

    case SET_CHILD_ASSOCIATE_CONTRACTOR:
      let type = action.payload?.type
      return {
        ...state,
        childAssociateContractor: { ...state.childAssociateContractor, [type]: action.payload?.data },
      };

    case SET_RATE_CARD_INFO:
      return {
        ...state,
        serviceRateCard: action.payload
      };

    case SET_SERVICES:
      return {
        ...state,
        serviceList: action.payload
      };

    case SET_SERVICE_STATE_LIST:
      return {
        ...state,
        serviceStateList: action.payload
      };

    case SET_SELECTED_SERVICE:
      return {
        ...state,
        selectedService: action.payload
      };

    case MODAL_OPEN_CLASS_LIST:
      return {
        ...state,
        modalOpenClass: action.payload
      };

    case SET_SELECTED_CERTIFICATE:
      return {
        ...state,
        selectedCertificate: action.payload
      };

    case SET_ADD_USER_LIST:
      return {
        ...state,
        addUserList: action.payload
      };

    case SET_PARENT_USER:
      return {
        ...state,
        parentAddUser: action.payload
      };

    case SET_SELECTED_USER:
      return {
        ...state,
        addSelectedUser: action.payload
      };

    case SET_EDITED_CYLINDER_TYPE:
      return {
        ...state,
        editCylinderType: action.payload
      };

    case SET_NON_ASSOCIATE_USERS:
      return {
        ...state,
        nonAssociateUsers: action.payload
      };
    case SEARCH_NON_ASSOCIATE_USERS:
      return {
        ...state,
        searchNonAssociateUsers: action.payload
      };

    case SET_DEALER_USER_LIST:
      return {
        ...state,
        dealerUserList: action.payload
      };

    case SET_ASSOCIATE_RECYCLER_LIST:
      return {
        ...state,
        associateRecycler: action.payload
      };

    case SET_ASSOCIATE_PROCESSOR_LIST:
      return {
        ...state,
        associateProcessor: action.payload
      };

    case SET_ASSOCIATE_DISPOSER_LIST:
      return {
        ...state,
        associateDisposer: action.payload
      };
    case SET_ASSOCIATE_TRANSPORTER_LIST:
      return {
        ...state,
        associateTransporter: action.payload
      };

    case RESET_ADMIN_JOB:
      return {
        ...state, ...action.payload
      };

    case USER_KEY:
      return {
        ...state,
        userKey: action.payload
      };

    case SET_VIEW_DETAILS_DATA:
      return {
        ...state,
        userViewData: action?.payload,
      };

    case SET_FILL_CYLINDER_LIST:
      const response = action.payload;
      const keyName = action.keyName;

      return {
        ...state,
        [keyName]: response,
      };

    default:
      return { ...state };
  }
};
